import React from 'react';
import './VideoBanner.css';
import bgImage from '../../assets/introImage.jpg'; // Replace with your actual image file

export const VideoBanner = () => {
  return (
    <section className="video-section">
      <img src={bgImage} alt="Background" className="video-background" />
      <div className="video-overlay">
        <h1 className="main-title">Motatec Asia</h1>
        <p className="typewriter-text">Premium Automotive Parts, Delivered Fast.</p>
      </div>
    </section>
  );
};
